import React, { useState } from "react";
import DivButton from "./Generic/DivButton";
import { Document, Page, pdfjs } from "react-pdf";
import "./LegalDoc.css";
// import EULA from "https://qfp-logos.s3.amazonaws.com/legal/EULA+Final.pdf";
// import PrivacyPolicy from "https://qfp-logos.s3.amazonaws.com/legal/Privacy+Policy+Draft+Final.pdf";
// import TermsOfUse from "https://qfp-logos.s3.amazonaws.com/legal/Terms+of+Use+Final.pdf";
// import WebsiteDisclosureNotes from "https://qfp-logos.s3.amazonaws.com/legal/Web+site+Disclosure+Notes+Final.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

export function LegalDoc(props) {
  const [open, setOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);

  function handleAccept() {
    setOpen(false);
    if (props.handleAccept !== undefined) {
      props.handleAccept();
    }
  }
  if (open) {
    return (
      <div className="DocPopup">
        <div className="DocContainer">
          <h2>Please review the </h2>
          <h2>{props.children}</h2>
          <div className="DocText">
            <Document
              file={props.DocURL}
              onLoadSuccess={({ numPages }) => {
                // console.log("numPages :>> ", numPages);
                setNumPages(numPages);
              }}
            >
              {Array.from(Array(numPages).keys()).map((page) => {
                // console.log("page :>> ", page);
                return (
                  <Page
                    pageNumber={page + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    customTextRenderer={false}
                    key={page}
                  />
                );
              })}
            </Document>
            <div className="DocButtons">
              <DivButton classList="small" onClick={handleAccept}>
                Accept
              </DivButton>
              <a href={props.DocURL} className="divButton">
                Download
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <DivButton
        classList={
          props.classList === undefined ? "small" : "small " + props.classList
        }
        onClick={() => {
          if (props.onClick !== undefined) props.onClick();
          setOpen(true);
        }}
      >
        {props.children}
      </DivButton>
    );
  }
}
